export const GET_LIST_AGENCY = {
    REQUEST: 'GET_LIST_AGENCY_REQUEST',
    SUCCESS: 'GET_LIST_AGENCY_SUCCESS',
    FAILED: 'GET_LIST_AGENCY_FAILED',
};
